// extracted by mini-css-extract-plugin
export default {"propertyItemList":"PropertyItemList_propertyItemList__SVEYz","propertyItem":"PropertyItemList_propertyItem__+NteE"};